/**
 * @generated SignedSource<<b5971d2197ae5381a8d06347bcb46863>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TableFocusScrollSubscription$variables = {
  widgetId: string;
};
export type TableFocusScrollSubscription$data = {
  readonly widgetFocusScrollChanged: string;
};
export type TableFocusScrollSubscription = {
  response: TableFocusScrollSubscription$data;
  variables: TableFocusScrollSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "widgetId",
        "variableName": "widgetId"
      }
    ],
    "kind": "ScalarField",
    "name": "widgetFocusScrollChanged",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TableFocusScrollSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TableFocusScrollSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c1eadf935d433fd1558c85d12454f8d2",
    "id": null,
    "metadata": {},
    "name": "TableFocusScrollSubscription",
    "operationKind": "subscription",
    "text": "subscription TableFocusScrollSubscription(\n  $widgetId: ID!\n) {\n  widgetFocusScrollChanged(widgetId: $widgetId)\n}\n"
  }
};
})();

(node as any).hash = "8b5099e2f2e39ae5fc51a5bc535533c4";

export default node;
